'use client';

import type { FeaturesCategoriesProps } from '@/core/types';

import React from 'react';

import { Lordicon } from '@/components/lordicon';
import { Box, Link, Button, Container, Typography } from '@/components/ui';

export default function FeaturesCategories({
  title,
  description,
  items,
  buttons,
  className = '',
}: FeaturesCategoriesProps) {
  return (
    <section className={`${className} bg-light-gray/56`}>
      <Container>
        <Box className="text-center mb-8 md:mb-20">
          {title && (
            <Typography
              variant="h2"
              className="text-center uppercase text-primary text-3xl md:text-[42px] font-bold mb-2 md:mb-8"
            >
              {title}
            </Typography>
          )}
          {description && (
            <Typography
              variant="body1"
              paragraph
              className="text-center font-medium text-base md:text-2xl max-w-3xl mx-auto"
            >
              {description}
            </Typography>
          )}
        </Box>

        <Box className="grid lg:grid-cols-[repeat(4,_minmax(150px,_1fr))] gap-3">
          {items?.map((item, index) => (
            <Link
              key={index}
              href={item.link}
              className="cursor-pointer flex items-center border-3 border-white text-gray-600 bg-white rounded-4xl shadow-box flex-col px-6 py-4 xl:py-12 transition-colors hover:!border-primary"
            >
              <Box className="flex flex-col items-center">
                <Lordicon icon={item.icon} size={56} className="mb-2" />
                <Typography
                  variant="body1"
                  className="text-center text-lg lg:text-sm xl:text-lg font-medium"
                >
                  {item.title}
                </Typography>
              </Box>
            </Link>
          ))}
        </Box>

        {buttons && buttons.length > 0 && (
          <Box className="flex flex-col items-center md:flex-row justify-center gap-4 mt-8 md:mt-20">
            {buttons.map((button, index) => (
              <Button
                key={index}
                href={button.link}
                variant={button.variant}
                className={`min-w-[180px] ${button.className}`}
              >
                {button.text}
              </Button>
            ))}
          </Box>
        )}
      </Container>
    </section>
  );
}
